import { useContext } from 'react'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useInvoice, { useInvoiceForm } from '@hooks/useInvoice'

import InvoiceDetails from '../InvoiceDetails'
import InvoiceTools from '../../../../components/InvoiceTools'
import PageLayout from '../../../../components/PageLayout'

interface PageContentProps {
  invoiceId: number,
}

const PageContent = (props: PageContentProps) => {
  const { invoiceId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateInvoice,
    },
  } = pageContext

  const invoicePayload = useInvoice({ id: invoiceId })
  const {
    invoice,
    callbacks: {
      updateInvoice: updateFn,
    },
    loading,
    updating,
  } = invoicePayload

  const invoiceFormPayload = useInvoiceForm(
    invoice,
    { customRequiredFields: [{ key: 'due_date' }], validateOn: 'change' },
  )
  const { entityState, saveEnabled } = invoiceFormPayload

  const updateInvoicePayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Invoice Updated',
  }

  return (
    <PageLayout invoicePayload={invoicePayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <InvoiceDetails invoiceFormPayload={invoiceFormPayload} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                //@ts-expect-error
                marginLeft="auto"
                onClick={() => updateInvoice(updateInvoicePayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <InvoiceTools invoicePayload={invoicePayload} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
